var map = {
	"./MenteseAdalari/batnaz.json": 136,
	"./MenteseAdalari/coban.json": 137,
	"./MenteseAdalari/esekler.json": 138,
	"./MenteseAdalari/herke.json": 139,
	"./MenteseAdalari/ileriye.json": 140,
	"./MenteseAdalari/ilyaki.json": 141,
	"./MenteseAdalari/incirli.json": 142,
	"./MenteseAdalari/istanbulya.json": 143,
	"./MenteseAdalari/istankoy.json": 144,
	"./MenteseAdalari/kelemez.json": 145,
	"./MenteseAdalari/kerpe.json": 146,
	"./MenteseAdalari/kizilhisar.json": 147,
	"./MenteseAdalari/rodos.json": 148,
	"./MenteseAdalari/sombeki.json": 149,
	"./SaruhanAdalari/rodos.json": 150,
	"./accto_greece_adalar_denizi_eez.json": 151,
	"./accto_greece_eez.json": 152,
	"./bab-el-mandeb.json": 153,
	"./blacksea_eez.json": 154,
	"./bulgarian_eez.json": 155,
	"./canakkaleStraits.json": 156,
	"./cyprus.json": 157,
	"./egypt.json": 158,
	"./georgian_eez.json": 159,
	"./gibraltarStraits.json": 160,
	"./greece.json": 161,
	"./hormuzStraits.json": 162,
	"./istanbulStraits.json": 163,
	"./libya.json": 164,
	"./lines.json": 74,
	"./marmarasea_eez.json": 165,
	"./mediterraneansea_eez.json": 166,
	"./romanian_eez.json": 167,
	"./russian_eez.json": 168,
	"./suezcanal.json": 169,
	"./trlibyakomsukiyilar.json": 170,
	"./trmap.json": 171,
	"./ukrainian_eez.json": 172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 135;